var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.82 367.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f4;}.cls-2,.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#ffc20c;stroke-width:5px;}.cls-2,.cls-4{stroke-linecap:round;}.cls-3{fill:#ffc20c;}.cls-4,.cls-5{stroke:#000;stroke-width:9px;}.cls-6{stroke:#555;stroke-width:3px;}.cls-7{fill:#777;}.cls-8{fill:#333;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 268.21,
    cy: 176.89,
    r: 167.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.82,157.25V139.14a13,13,0,0,0-13-13h-56a13,13,0,0,1-13-13V95a13,13,0,0,1,13-13h21.45a13,13,0,0,0,13-13V50.84a13,13,0,0,0-13-13H73.37a13,13,0,0,0-13,13V69a13,13,0,0,0,13,13h0a13,13,0,0,1,13,13V113.1a13,13,0,0,1-13,13H13a13,13,0,0,0-13,13v18.11a13,13,0,0,0,13,13H72.78a13,13,0,0,1,13,13v18.11c.32,16.57-35.83,13-43,13h-.05a13,13,0,0,0-13,13v18.11a13,13,0,0,0,13,13H75.59a13,13,0,0,1,13,13v18.11a13,13,0,0,1-13,13H38.68a13,13,0,0,0-13,13v18.11a13,13,0,0,0,13,13h415.6a13,13,0,0,0,13-13V315.75a13,13,0,0,0-13-13H433a13,13,0,0,1-13-13V271.6a13,13,0,0,1,13-13h36.62a13,13,0,0,0,13-13V227.45a13,13,0,0,0-13-13H451.54a13,13,0,0,1-13-13V183.3a13,13,0,0,1,13-13H491.8A13,13,0,0,0,504.82,157.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.3,
    y1: 113.98,
    x2: 93.6,
    y2: 113.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.3,
    y1: 123.29,
    x2: 93.6,
    y2: 123.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 61.3,
    y1: 132.61,
    x2: 93.6,
    y2: 132.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 435.9,
    y1: 246.29,
    x2: 468.2,
    y2: 246.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 435.9,
    y1: 255.6,
    x2: 468.2,
    y2: 255.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 435.9,
    y1: 264.91,
    x2: 468.2,
    y2: 264.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.27,
    y1: 2.5,
    x2: 315.58,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.27,
    y1: 11.81,
    x2: 315.58,
    y2: 11.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 283.27,
    y1: 21.12,
    x2: 315.58,
    y2: 21.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.69,363.68a11.42,11.42,0,0,1-11.41-12.26l15.56-216.78A11.47,11.47,0,0,1,169.25,124H348.1a11.47,11.47,0,0,1,11.41,10.62l15.56,216.78a11.42,11.42,0,0,1-11.41,12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,127.52a8,8,0,0,1,7.92,7.37l15.56,216.78a7.94,7.94,0,0,1-7.92,8.51h-210a7.94,7.94,0,0,1-7.92-8.51l15.56-216.78a8,8,0,0,1,7.92-7.37H348.1m0-7H169.25a14.93,14.93,0,0,0-14.9,13.87L138.78,351.17a15,15,0,0,0,14.91,16h210a15,15,0,0,0,14.91-16L363,134.39a14.93,14.93,0,0,0-14.9-13.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.88,
    cy: 191.69,
    r: 11.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.47,
    cy: 191.69,
    r: 11.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236,246.29A23.1,23.1,0,0,1,242.64,230a22.47,22.47,0,0,1,32.07,0,23.1,23.1,0,0,1,6.64,16.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M248.62,44.09h20.46a47,47,0,0,1,47,47v32.2a0,0,0,0,1,0,0H201.62a0,0,0,0,1,0,0V91.09a47,47,0,0,1,47-47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 103.75,
    cy: 214.15,
    r: 10.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 402.34,
    cy: 254.53,
    r: 8.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M118.64,292.37h0A1.65,1.65,0,0,1,117,294h-3.22v3.21a1.65,1.65,0,0,1-1.65,1.65h0a1.65,1.65,0,0,1-1.65-1.65V294h-3.22a1.65,1.65,0,0,1-1.65-1.65h0a1.65,1.65,0,0,1,1.65-1.65h3.22V287.5a1.65,1.65,0,0,1,1.65-1.65h0a1.65,1.65,0,0,1,1.65,1.65v3.22H117A1.65,1.65,0,0,1,118.64,292.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M416.27,179.82h0a2,2,0,0,1-2.88,0L410.58,177l-2.81,2.81a2,2,0,0,1-2.88,0h0a2,2,0,0,1,0-2.88l2.81-2.81-2.81-2.81a2,2,0,0,1,0-2.89h0a2,2,0,0,1,2.88,0l2.81,2.81,2.81-2.81a2,2,0,0,1,2.88,0h0a2.06,2.06,0,0,1,0,2.89l-2.82,2.81,2.81,2.81A2,2,0,0,1,416.27,179.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M146,75.87l-.27-1.18a10.64,10.64,0,0,1,.22-5.92,20.34,20.34,0,0,1,4-6.33,21.37,21.37,0,0,0,4.61-7.55,14.36,14.36,0,0,0,.07-7.38,14.57,14.57,0,0,0-4.45-7.95,14.86,14.86,0,0,0-8-3.51,28.3,28.3,0,0,0-10.22.63,27.42,27.42,0,0,0-7.66,3,32.34,32.34,0,0,0-6.61,5.11l7.1,7.82a20.65,20.65,0,0,1,3.91-3.34,13.64,13.64,0,0,1,4.42-1.92c2.38-.54,4.24-.48,5.58.2a4.93,4.93,0,0,1,2.6,3.56,6.16,6.16,0,0,1-.33,3.8,23.68,23.68,0,0,1-3.25,5,26.23,26.23,0,0,0-4.65,8.38,15.73,15.73,0,0,0-.1,8,26,26,0,0,0,1,3.5Zm2.64,20.4A7.74,7.74,0,0,0,150.73,93a7,7,0,0,0,.17-3.85,6.76,6.76,0,0,0-1.81-3.31,7.91,7.91,0,0,0-3.28-2,7.37,7.37,0,0,0-3.9-.15,7.12,7.12,0,0,0-3.36,1.82,8.35,8.35,0,0,0-2.11,3.26,6.57,6.57,0,0,0-.24,3.77,7,7,0,0,0,1.83,3.4,7.78,7.78,0,0,0,3.33,2,7.36,7.36,0,0,0,3.86.16A7.17,7.17,0,0,0,148.66,96.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M365,51.85l.27-1.18a10.64,10.64,0,0,0-.22-5.92,20.47,20.47,0,0,0-4-6.33,21.27,21.27,0,0,1-4.62-7.55,14.47,14.47,0,0,1-.07-7.38,14.57,14.57,0,0,1,4.45-7.95,14.86,14.86,0,0,1,8-3.51,28.29,28.29,0,0,1,10.22.63,27.42,27.42,0,0,1,7.66,3,32.34,32.34,0,0,1,6.61,5.11l-7.1,7.82a20.48,20.48,0,0,0-3.9-3.33,13.5,13.5,0,0,0-4.43-1.93c-2.37-.54-4.24-.48-5.58.2a5,5,0,0,0-2.6,3.56,6.16,6.16,0,0,0,.34,3.8,23.16,23.16,0,0,0,3.24,5,26.48,26.48,0,0,1,4.66,8.38,15.74,15.74,0,0,1,.09,8,26,26,0,0,1-1,3.5Zm-2.64,20.4A7.74,7.74,0,0,1,360.26,69a7.15,7.15,0,0,1,1.64-7.16,7.88,7.88,0,0,1,3.29-2,7.37,7.37,0,0,1,3.9-.15,7,7,0,0,1,3.35,1.82,8.37,8.37,0,0,1,2.12,3.26,6.66,6.66,0,0,1,.23,3.77,7,7,0,0,1-1.83,3.4,7.78,7.78,0,0,1-3.33,2,7.36,7.36,0,0,1-3.86.16A7.17,7.17,0,0,1,362.33,72.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProducts);
export default __webpack_public_path__ + "static/media/no_products.901a154d135f6b305d109628008a82bb.svg";
export { ForwardRef as ReactComponent };